import { gql } from '@apollo/client'

export const GET_FORUM_TOPICS = gql`
  query GetForumTopics($courseContentId: ID!, $page: Int, $perPage: Int) {
    forumTopics(
      courseContentId: $courseContentId
      page: $page
      perPage: $perPage
    ) {
      commentsEnabled
      totalCount
      totalPages
      currentPage
      perPage
      topics {
        id
        title
        description
        fixed
        answered
        answeredAt
        postsCount
        createdAt
        courseContentId
        user {
          id
          fullName
          firstName
          lastName
          email
          avatarUrl
        }
      }
    }
  }
`

export const GET_FORUM_TOPIC = gql`
  query GetForumTopic($id: ID!, $postsLimit: Int, $postsOffset: Int) {
    forumTopic(id: $id) {
      id
      title
      description
      fixed
      answered
      answeredAt
      postsCount
      createdAt
      courseContentId
      user {
        id
        fullName
        firstName
        lastName
        email
        avatarUrl
      }
      posts(limit: $postsLimit, offset: $postsOffset) {
        id
        body
        createdAt
        user {
          id
          fullName
          firstName
          lastName
          email
          avatarUrl
        }
      }
    }
  }
`
